import React, { useEffect, useState } from 'react';
import { fetchEntityImageUrl, isManagedImageKey } from '../../services/entityImages';

/**
 * ТЗ V5 №12: картинка объекта иерархии. Загруженная через портал — байты по
 * GET /entity-images/{type}/{id} и временная blob-ссылка (освобождается при
 * смене картинки и уходе со страницы). Старая внешняя ссылка — как раньше.
 * Ошибка или отсутствие — нейтральная заглушка, никогда не чужая картинка.
 */
const EntityImage = ({ entityType, entityId, image, alt = '', placeholder = 'Нет изображения', placeholderClassName = '' }) => {
  const managed = isManagedImageKey(image);
  const [state, setState] = useState({ key: '', url: '', failed: false });
  const key = managed ? `${entityType}/${entityId}/${image}` : '';

  useEffect(() => {
    if (!key) return undefined;
    let cancelled = false;
    let objectUrl = '';
    setState({ key, url: '', failed: false });
    fetchEntityImageUrl(entityType, entityId)
      .then((url) => {
        objectUrl = url || '';
        if (cancelled) {
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          return;
        }
        setState({ key, url: objectUrl, failed: !objectUrl });
      })
      .catch(() => { if (!cancelled) setState({ key, url: '', failed: true }); });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [key, entityType, entityId]);

  const [legacyBroken, setLegacyBroken] = useState(false);
  useEffect(() => { setLegacyBroken(false); }, [image]);

  const renderPlaceholder = () => <div className={placeholderClassName}>{placeholder}</div>;

  if (!image) return renderPlaceholder();
  if (!managed) {
    return legacyBroken ? renderPlaceholder() : <img src={image} alt={alt} onError={() => setLegacyBroken(true)} />;
  }
  if (state.key !== key || (!state.url && !state.failed)) return <div className={placeholderClassName}>Загрузка…</div>;
  if (!state.url) return renderPlaceholder();
  return <img src={state.url} alt={alt} />;
};

export default EntityImage;
